import { ConfirmDialog } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { useBlocker } from '@tyro/router/hooks';

interface ConfirmChangesModalProps {
  isDirty: boolean;
}

export function ConfirmChangesModal({ isDirty }: ConfirmChangesModalProps) {
  const { t } = useTranslation(['common']);

  const blocker = useBlocker(isDirty);

  return (
    <ConfirmDialog
      open={blocker.state === 'blocked'}
      title={t('common:confirmDialog.areYouSureYouWantToChangePage')}
      description={t('common:confirmDialog.youHaveUnsavedChanges')}
      confirmText={t('common:actions.continue')}
      onConfirm={() => blocker?.proceed?.()}
      onClose={() => blocker?.reset?.()}
    />
  );
}
